
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import IstihkakList from "@/components/lists/haciz/IstihkakList.vue";
import YedieminInfo from "@/components/infos/haciz/YedieminInfo.vue";
import NoterPicker from "@/components/pickers/NoterPicker.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";

@Component({
  components: {
    FormDialog,
    IstihkakList,
    YedieminInfo,
    NoterPicker,
    EnabledSwitch,
    Dates,
    Tutar,
  }
})
export default class TurkUluslararasiGemiSicilineKayitliGemilerForm extends Mixins(ObjectInputMixin) {
}
